<div class="h-screen flex overflow-hidden bg-background text-foreground">
  <aside
    class="hidden lg:flex shrink-0 z-20 border-r border-border bg-muted flex-col justify-between transition-all duration-300 sticky top-0 h-screen overflow-y-auto"
    [class.w-64]="sidebarExpanded"
    [class.w-16]="!sidebarExpanded"
    [style.min-width]="sidebarExpanded ? '256px' : '64px'"
    [class.shell-sidebar--collapsed]="!sidebarExpanded"
  >
    <app-sidebar
      [menuItems]="menuItems"
      [sidebarExpanded]="sidebarExpanded"
      (toggleSidebar)="toggleSidebar()"
      (expandSidebar)="sidebarExpanded = true"
    ></app-sidebar>
  </aside>

  <!-- Mobile sidebar (mockup Header menu button) -->
  <div
    *ngIf="mobileDrawerOpen"
    class="fixed inset-0 z-40 lg:hidden"
    aria-hidden="true"
  >
    <div
      class="absolute inset-0 bg-black/40"
      (click)="mobileDrawerOpen = false"
    ></div>
    <aside
      class="absolute left-0 top-0 bottom-0 w-64 max-w-[85vw] border-r border-border bg-muted flex flex-col z-50 shadow-elevation-md"
    >
      <app-sidebar
        [menuItems]="menuItems"
        [sidebarExpanded]="true"
        (toggleSidebar)="mobileDrawerOpen = false"
        (expandSidebar)="mobileDrawerOpen = true"
      ></app-sidebar>
    </aside>
  </div>

  <div class="flex-1 flex flex-col min-h-0 overflow-hidden relative">
    <app-shell-header-mockup
      (menuClick)="mobileDrawerOpen = true"
    >
      <div
        *ngIf="cats?.length"
        shell-header-modules
        class="grid grid-cols-3 gap-[6px]"
      >
        <a
          *ngFor="let cat of cats"
          [href]="cat.webUrl"
          class="content-stretch flex flex-col gap-[12px] items-center justify-center p-[16px] relative rounded-[12px] cursor-pointer transition-all hover:bg-muted no-underline text-inherit"
        >
          <div
            class="relative shrink-0 w-10 h-10 flex items-center justify-center text-foreground"
          >
            <i
              class="text-2xl"
              [ngClass]="cat.iconClass ? cat.iconClass : 'uni uni-overview'"
            ></i>
          </div>
          <div class="flex flex-col gap-1 items-center text-center w-full">
            <p class="text-sm text-foreground">{{ cat.webName }}</p>
          </div>
        </a>
      </div>
    </app-shell-header-mockup>
    <main class="flex-1 min-h-0 overflow-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
